var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTexticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8124 6.70535V3.34127C15.8124 3.17436 15.6771 3.03906 15.5098 3.03906H10.0004H4.49104C4.32378 3.03906 4.18848 3.17436 4.18848 3.34127V6.70535C4.18848 6.87262 4.32378 7.00792 4.49104 7.00792H6.09762C6.26453 7.00792 6.39983 6.87262 6.39983 6.70535V5.55298C6.39983 5.38572 6.53549 5.25041 6.70239 5.25041H8.592C8.75927 5.25041 8.89457 5.38572 8.89457 5.55298V13.8678C8.89457 14.0351 8.75927 14.1704 8.592 14.1704H7.76563C7.59837 14.1704 7.46307 14.3057 7.46307 14.473V16.0795C7.46307 16.2464 7.59837 16.3817 7.76563 16.3817H10.0004H12.2352C12.4025 16.3817 12.5378 16.2464 12.5378 16.0795V14.473C12.5378 14.3057 12.4025 14.1704 12.2352 14.1704H11.4088C11.2416 14.1704 11.1063 14.0351 11.1063 13.8678V5.55298C11.1063 5.38572 11.2416 5.25041 11.4088 5.25041H13.2985C13.4654 5.25041 13.601 5.38572 13.601 5.55298V6.70535C13.601 6.87262 13.7363 7.00792 13.9032 7.00792H15.5098C15.6771 7.00792 15.8124 6.87262 15.8124 6.70535Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTexticon);
export default __webpack_public_path__ + "static/media/texticon.cbaa5168a556d4181ab3651199d7f22c.svg";
export { ForwardRef as ReactComponent };